import React from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { selectors as currentUserSelectors } from '@rover/react-lib/src/redux/ducks/currentUser.duck';

import RoverProtectPage from './RoverProtectPage';

const selector = (state) => ({
  personOpk: currentUserSelectors.getOpk(state),
});

const RoverProtectPageContainer = (): JSX.Element => (
  <Connect selector={selector}>
    {(connectedProps) => <RoverProtectPage {...connectedProps} />}
  </Connect>
);

export default RoverProtectPageContainer;
